/**
 * Logger utility with localStorage flag control
 * All logs are hidden in production unless DEBUG_LOGS flag is set in localStorage
 */

import { STORAGE_KEYS } from '../config/storage-keys';

/**
 * Check if debug logging is enabled
 */
function isDebugLoggingEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  
  try {
    const flag = window.localStorage?.getItem(STORAGE_KEYS.DEBUG_LOGS);
    return flag === 'true';
  } catch {
    return false;
  }
}

/**
 * Enable debug logging
 */
export function enableDebugLogs(): void {
  if (typeof window === 'undefined') {
    return;
  }
  
  try {
    window.localStorage?.setItem(STORAGE_KEYS.DEBUG_LOGS, 'true');
  } catch (error) {
    // Silently fail if localStorage is not available
  }
}

/**
 * Disable debug logging
 */
export function disableDebugLogs(): void {
  if (typeof window === 'undefined') {
    return;
  }
  
  try {
    window.localStorage?.removeItem(STORAGE_KEYS.DEBUG_LOGS);
  } catch (error) {
    // Silently fail if localStorage is not available
  }
}

/**
 * Logger object that respects the debug flag
 */
export const logger = {
  log: (...args: unknown[]): void => {
    if (isDebugLoggingEnabled()) {
      console.log(...args);
    }
  },
  
  error: (...args: unknown[]): void => {
    if (isDebugLoggingEnabled()) {
      console.error(...args);
    }
  },
  
  warn: (...args: unknown[]): void => {
    if (isDebugLoggingEnabled()) {
      console.warn(...args);
    }
  },
  
  info: (...args: unknown[]): void => {
    if (isDebugLoggingEnabled()) {
      console.info(...args);
    }
  },
  
  debug: (...args: unknown[]): void => {
    if (isDebugLoggingEnabled()) {
      console.debug(...args);
    }
  },
};


